export enum SessionStorageItemKeys {
  ADVERTISER = 'advertiserId',
  AGENCY = 'agencyId',
  SESSION_ANNOUNCEMENT_CLOSE = 'group_announcement_close', // only for group removal phase 1
}

export const SessionStorageHelper = {
  getItem(key: SessionStorageItemKeys) {
    return sessionStorage.getItem(key);
  },
  getNumberItem(key: SessionStorageItemKeys) {
    const value = sessionStorage.getItem(key);
    return value ? parseInt(value, 10) : undefined;
  },
  setItem(key: SessionStorageItemKeys, value: string | number) {
    sessionStorage.setItem(key, value.toString());
  },
  removeItem(key: SessionStorageItemKeys) {
    sessionStorage.removeItem(key);
  },
};
